module.exports = __webpack_public_path__ + "media/img/heidrich-529411109b65ff848040b231ecb959fa.jpg";